export default __webpack_public_path__ + "static/media/AMO_Logo.9eaf3c74.png";